import { EntityId } from "@swoft/core";

/**
 * Strongly-typed identifier for Task aggregates.
 * 
 * Provides value object semantics for task identification,
 * ensuring type safety and preventing ID confusion across aggregates.
 */
export class TaskId extends EntityId {
  private readonly value: string;

  constructor(value: string) {
    super();
    this.value = value;
    if (!value || value.trim().length === 0) {
      throw new Error('TaskId cannot be empty');
    }
  }

  toString(): string {
    return this.value;
  }

  /**
   * Create a TaskId from a string value.
   * Useful for deserialization and API boundaries.
   */
  static fromString(value: string): TaskId {
    return new TaskId(value);
  }

  /**
   * Generate a new unique TaskId.
   * Uses timestamp-based generation for uniqueness.
   */
  static generate(): TaskId {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 8);
    return new TaskId(`task-${timestamp}-${random}`);
  }
}